import { Button } from "@heroui/react";
import { SectorFilterOptions } from "../../types/enums";

interface AccordionCheckboxGroupLabelProps {
    isFiltersLoading: boolean;
    handleOnClick: (value: SectorFilterOptions) => void;
}

export const AccordionCheckboxGroupLabel: React.FC<AccordionCheckboxGroupLabelProps> = ({ isFiltersLoading, handleOnClick }) => {


    return (
        isFiltersLoading ? null :
            // <div className="flex justify-end right-0 float-right h-14 items-center">
            <div className="flex flex-row gap-1 mx-2.5 mt-1 mb-0.5">
                <Button onPress={() => handleOnClick(SectorFilterOptions.ALL)} className="min-w-4.5 w-4.5 h-[70px] px-0 py-1 flex items-center justify-start rounded rotate-180 [writing-mode:vertical-rl]">
                    <span className="w-3.5 h-3.5 rounded-full bg-success-500"></span>
                    <label className="cursor-pointer font-semibold text-sm">All</label>
                </Button>
                <Button onPress={() => handleOnClick(SectorFilterOptions.FILTER)} className="min-w-4.5 w-4.5 h-[70px] px-0 py-1 flex items-center justify-start  rounded rotate-180 [writing-mode:vertical-rl]">
                    <span className="w-3.5 h-3.5 rounded-full bg-warning-500"></span>
                    <label className="cursor-pointer font-semibold text-sm">Filter</label>
                </Button>
                <Button onPress={() => handleOnClick(SectorFilterOptions.NONE)} className="min-w-4.5 w-4.5 h-[70px] px-0 py-1 flex items-center justify-start  rounded rotate-180 [writing-mode:vertical-rl]">
                    <span className="w-3.5 h-3.5 rounded-full bg-danger-500"></span>
                    <label className="cursor-pointer font-semibold text-sm">None</label>
                </Button>
            </div>




    );
};

